import type { IconData } from '@stacksjs/iconify-core'

export const filter1: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M24 6c-11.463 0-17.06.485-19.459.793C3.63 6.91 3 7.687 3 8.607v3.2c0 .96.342 1.884 1.006 2.577c1.895 1.978 6.395 6.354 12.87 10.624c.515.34.854.896.91 1.51c.636 6.849 1.219 11.527 1.528 13.83A1.91 1.91 0 0 0 21.216 42c.364 0 .72-.102 1.03-.295l5.026-3.136c.766-.477 1.333-1.204 1.52-2.087c.322-1.513.838-4.503 1.398-9.963c.063-.61.4-1.159.911-1.496c6.487-4.274 10.996-8.658 12.893-10.64c.664-.692 1.006-1.617 1.006-2.577v-3.2c0-.919-.63-1.696-1.541-1.813C41.059 6.485 35.463 6 24 6\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default filter1
